import { render } from "./ActionButton.vue?vue&type=template&id=8907d1be"
import script from "./ActionButton.vue?vue&type=script&setup=true&lang=js"
export * from "./ActionButton.vue?vue&type=script&setup=true&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/config-app/components/ActionButton.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "8907d1be"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('8907d1be', __exports__)) {
    api.reload('8907d1be', __exports__)
  }
  
  module.hot.accept("./ActionButton.vue?vue&type=template&id=8907d1be", () => {
    api.rerender('8907d1be', render)
  })

}


export default __exports__